module.exports = __webpack_public_path__ + "img/39_49.87b291e6.png";